import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FiCode, FiUsers, FiTrendingUp, FiAward } from 'react-icons/fi';
import './About.css';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const stats = [
    { icon: <FiCode />, value: '10+', label: 'Years Experience' },
    { icon: <FiUsers />, value: '50+', label: 'Team Members Led' },
    { icon: <FiTrendingUp />, value: '20+', label: 'Projects Delivered' },
    { icon: <FiAward />, value: '500+', label: 'Connections' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="about" className="about section" ref={ref}>
      <div className="container">
        <motion.div
          className="about-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">
            Engineering leader passionate about building great products and teams
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p>
              I'm a <strong>Director of Engineering</strong> with extensive experience
              in leading engineering teams and driving product development. Currently
              at <strong>Outcode Software</strong>, I focus on building scalable
              solutions and fostering high-performance engineering cultures.
            </p>
            <p>
              With a background from the <strong>School of Management, Tribhuvan
              University (SOMTU)</strong>, I combine technical expertise with business
              acumen to deliver impactful solutions.
            </p>
            <p>
              I believe in continuous learning, mentorship, and building products
              that make a real difference. My approach emphasizes collaboration,
              innovation, and sustainable engineering practices.
            </p>
          </motion.div>

          <motion.div
            className="about-stats"
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? 'visible' : 'hidden'}
          >
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className="stat-card"
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
